// src/pages/Register.js
import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { useNotification } from '../context/NotificationContext';

const API_BASE_URL = process.env.REACT_APP_API_URL;

const Register = () => {
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
  });
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { showNotification } = useNotification();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await axios.post(`${API_BASE_URL}/auth/register`, formData);
      showNotification('Inscription réussie ! Vous pouvez maintenant vous connecter.', 'success');
      navigate('/login');
    } catch (err) {
      if (err.response) {
        const { message } = err.response.data;
        setError(message);
      } else {
        console.error("Erreur réseau ou serveur", err);
        setError("Une erreur est survenue. Veuillez réessayer.");
      }
    }
  };

  return (
    <div className="flex justify-center items-center py-12">
      <div className="bg-white border border-slate-200 p-8 rounded-xl shadow-sm w-full max-w-md">
        <h2 className="text-2xl font-bold mb-2 text-center text-slate-800">Inscription</h2>
        <p className="text-slate-500 text-sm text-center mb-6">Créez votre compte client.</p>

        {error && <p className="text-red-500 mb-4 text-xs">{error}</p>}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-xs font-semibold uppercase tracking-wider text-slate-500 mb-1">
              Nom d'utilisateur <span className="text-rose-500">*</span>
            </label>
            <input
              type="text"
              name="username"
              placeholder="Ex: jdoe"
              value={formData.username}
              onChange={handleChange}
              required
              className="w-full rounded-lg border border-slate-200 bg-slate-50 p-2.5 text-sm text-slate-800 placeholder-slate-400 focus:bg-white focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 focus:outline-none transition-all"
            />
          </div>

          <div>
            <label className="block text-xs font-semibold uppercase tracking-wider text-slate-500 mb-1">
              Adresse email <span className="text-rose-500">*</span>
            </label>
            <input
              type="email"
              name="email"
              placeholder="Ex: john.doe@example.com"
              value={formData.email}
              onChange={handleChange}
              required
              className="w-full rounded-lg border border-slate-200 bg-slate-50 p-2.5 text-sm text-slate-800 placeholder-slate-400 focus:bg-white focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 focus:outline-none transition-all"
            />
          </div>

          <div>
            <label className="block text-xs font-semibold uppercase tracking-wider text-slate-500 mb-1">
              Mot de passe <span className="text-rose-500">*</span>
            </label>
            <input
              type="password"
              name="password"
              placeholder="•••••••• (min 6 caractères)"
              value={formData.password}
              onChange={handleChange}
              required
              className="w-full rounded-lg border border-slate-200 bg-slate-50 p-2.5 text-sm text-slate-800 placeholder-slate-400 focus:bg-white focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 focus:outline-none transition-all"
            />
          </div>

          <button
            type="submit"
            className="w-full bg-indigo-600 hover:bg-indigo-700 text-white font-medium py-2.5 rounded-lg text-sm transition-colors shadow-sm shadow-indigo-600/10 mt-6"
          >
            S'inscrire
          </button>
        </form>

        <p className="text-slate-500 text-xs text-center mt-6">
          Déjà inscrit ?{" "}
          <Link to="/login" className="text-indigo-600 hover:underline font-semibold">
            Se connecter
          </Link>
        </p>
      </div>
    </div>
  );
};

export default Register;
